const NoSearchResultsCard = () => (
  <div className="w-full p-8 bg-grays-light border-b border-grays-mediumlight">
    <h2 className="text-center text-primary">
      Sorry, no results match your query.
    </h2>
  </div>
)

export default NoSearchResultsCard
